/**
 * Single-seller identity passed into `PayPalCheckout` for client-side rail /
 * eligibility gating (CCP / Apple Pay / Google Pay button rendering).
 *
 * Money authority lives elsewhere: under Full A the server resolves
 * `CheckoutIntent` → `purchase_units[]`. Nothing on this shape is trusted
 * for amounts.
 *
 * @see components/cart/paypal-checkout.tsx — consumer
 * @see .tondocs/payments/CUTOVER_STEP_3_REVIEW.md Finding #7 — the drift
 *      that motivated centralising the builder (auction-winner sheet had
 *      missed `capabilities`, silently hiding Apple/Google Pay).
 */
export interface SellerDetail {
  sellerId: string;
  paypalMerchantId: string;
  capabilities?: string[];
}

/**
 * Build a `SellerDetail` from any source that carries the three fields the
 * gating logic needs. Used by every single-seller checkout surface (cart's
 * `checkoutSellerCalc`, offer sheet items, auction-winner items) — each
 * previously hand-rolled the literal, so a field could (and did) get dropped
 * on one surface without the others noticing.
 *
 * `paypalMerchantId` falls back to `""` because the consumer typings expect
 * a non-null string; the empty value still routes through the upstream
 * `availableProviders` gate.
 */
export function buildSellerDetail(source: {
  sellerId: string;
  paypalMerchantId?: string | null;
  paypalCapabilities?: string[];
}): SellerDetail {
  return {
    sellerId: source.sellerId,
    paypalMerchantId: source.paypalMerchantId || "",
    capabilities: source.paypalCapabilities,
  };
}
